<button
  class="statistics_button"
  (click)="downloadAnalytics()"
  *ngxPermissionsOnly="permissions.CAN_DOWNLOAD_ANALYTICS"
>
  <nb-icon class="statistics_button__icon" icon="download-outline"></nb-icon>
  <span class="statistics_button__text">Download analytics</span>
</button>
